import { useContext } from 'react';

import { ToolbarSettingsContext } from 'bundles/coursera-toolbar/context/ToolbarSettingsContext';

/**
 * Hook for accessing and modifying developer toolbar settings.
 * Must be used within ToolbarSettingsProvider.
 */
export const useToolbarSettings = () => {
  const context = useContext(ToolbarSettingsContext);
  if (context === null) {
    throw new Error('useToolbarSettings must be used within ToolbarSettingsProvider');
  }
  return context;
};
